import React from 'react'
import './styles.scss'

/**
 * Button
 * @param {object} props
 * @param {string} props.label
 * @param {function} [props.onClick]
 * @param {'button'|'reset'|'submit'} [props.type]
 * @param {boolean} [props.disabled]
 * @param {string} [props.className]
 * @param {'primary'|'secondary'} [props.color]
 * @param {'small'} [props.size]
 *
 * @returns {React.Component}
 */
const Button = (props) => {
  const {
    disabled = false, label, onClick = null, className = '',
    type = 'button', color = 'primary', size = ''
  } = props

  const classname = `nx-button ${color} ${size} ${className}`.trim()

  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={classname}
    >
      {label}
    </button>
  )
}

export default Button
